(function ($) {

	$(function () {

		$(".utmdclinks-copy").on("click", function(event){
			$(this).select();
		});

	});

}(jQuery));
